// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/new-index.styl'
import VueAxios from 'vue-axios'
import createAxios from '@/api/axios'
import { getSession } from '@/api/common'
import '@/filter'
import { createSocket } from '@/api/websocket'
import { creatGK3Socket } from '@/common/websocket/index'
import '@/common/websocket/emergency.js'
import echarts from 'echarts'
import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
import './util/flexible'
import { has } from '@/util/btnPermission'
import { message } from '@/util/Utils'
import { errorCollection } from '@/api/dmp/dmpCollection'
import { getIntranetData } from '@/api/login'
// 引入拖动方法（不可删）
import drag from '@/util/drag' //NOSONAR
import VueI18n from 'vue-i18n'
import i18n from '@/common/i18n'

import vAlert from '@/components/voice/voice'
import AlertWalkie from '@/components/walkie/Walkie'
import $ from 'jquery'
import { gologin } from '@/util/loginAkSk'
// 防止多次点击

import preventReClick from '@/util/preventClick'
Vue.use(preventReClick);

Vue.prototype.$vAlert = vAlert.install
Vue.prototype.$AlertWalkie = AlertWalkie.install

Vue.prototype.$message = message
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
const axios = createAxios(router)
Vue.use(VueAxios, axios)
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(VueI18n)
Vue.use(has)

// 全局系统错误捕获
const errorHandler = error => {
  errorCollection('系统异常', '系统异常', {
    status: 200,
    data: { state: -1, msg: error.stack, operationType: 'SYSTEM_ERROR' },
  })
  console.log('前端全局异常', error)
}
Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = error => errorHandler(error)

const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem('appVersion') || ''
if (VUE_APP_VERSION !== vers) {
  localStorage.clear()
  window.localStorage.setItem('appVersion', VUE_APP_VERSION)
  location.reload()
}
// 仅私有化需要获取私有化配置数据
if (!store.getters.isCloud) {
  getIntranetData().then(res => {
    if (res.state === 0) {
      // 图标网站名设置
      localStorage.setItem('CPMPANY_ICON', res.data.CPMPANY_ICON)
      localStorage.setItem('SYS_ICON', res.data.SYS_ICON)
      localStorage.setItem('SYS_NAME', res.data.SYS_NAME)
      localStorage.setItem('SYS_WEBSITE', res.data.SYS_WEBSITE)
      // 页签title设置
      document.title = i18n.t(res.data.SYS_NAME)
    }
  })
  let urlData = window.location.href
  if (
    urlData.indexOf('realvideo') < 0 &&
    !urlData.includes('/monitor') &&
    !urlData.includes('/externalHistory') &&
    !urlData.includes('/Intercom')
  ) {
    gologin()
  }
} else {
  // 页签title设置
  document.title = i18n.t('现场作业智能管控平台')
}

// 前端全局配置，刷新 界面时写入
axios.get('./config.json?number=' + Math.random()).then(res => {
  console.log('config', res.data)
  const config = res.data
  if (config) {
    var innerIp = config.VUE_APP_INNER_IP || process.env.VUE_APP_INNER_IP
    var outerIp = config.VUE_APP_OUTER_IP || process.env.VUE_APP_OUTER_IP
    var srsOuterPort = config.VUE_APP_OUTER_SRS_PORT
    var msOuterPort = config.VUE_APP_OUTER_MS_PORT
    var mediasoupWsUrl = config.VUE_APP_MEDIASOUOP_WS_URL || process.env.VUE_APP_MEDIASOUOP_WS_URL
    var srsWsUrl = config.VUE_APP_SRS_WS_URL || process.env.VUE_APP_SRS_WS_URL
    // 获取当前网页ip
    if (innerIp && outerIp && mediasoupWsUrl && srsWsUrl) {
      let thisIp = location.hostname
      if (thisIp.indexOf(innerIp) > -1) {
        mediasoupWsUrl = mediasoupWsUrl.replace(outerIp, innerIp)
        srsWsUrl = srsWsUrl.replace(outerIp, innerIp)
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        mediasoupWsUrl = mediasoupWsUrl.replace(innerIp, outerIp)
        srsWsUrl = srsWsUrl.replace(innerIp, outerIp)
        if (srsOuterPort) {
          srsWsUrl = srsWsUrl.replace(':443', srsOuterPort)
        }
        if (srsOuterPort) {
          mediasoupWsUrl = mediasoupWsUrl.replace(':4443', msOuterPort)
        }
      }
    }
    store.commit('changeSystemConfig', {
      serverType: config.VUE_APP_MAP_SERVER_TYEP || process.env.VUE_APP_MAP_SERVER_TYEP,
      streetLayerUrl: config.VUE_APP_STREET_LAYER_URL || process.env.VUE_APP_STREET_LAYER_URL,
      satelliteLayerUrl: config.VUE_APP_SATELLITE_LAYER_URL || process.env.VUE_APP_SATELLITE_LAYER_URL,
      streetEnLayerUrl: config.VUE_APP_STREET_EN_LAYER_URL || process.env.VUE_APP_STREET_EN_LAYER_URL,
      transMethod: config.VUE_APP_MAP_TRANS_METHOD || process.env.VUE_APP_MAP_TRANS_METHOD,
      rtcType: config.VUE_APP_RTC_TYPE || process.env.VUE_APP_RTC_TYPE,
      mediasoupWsUrl: mediasoupWsUrl,
      srsWsUrl: srsWsUrl,
      innerIp: innerIp,
      outerIp: outerIp,
      translateOpen: config.VUE_APP_TRANSLATE_OPEN || process.env.VUE_APP_TRANSLATE_OPEN,
      translateAPP: config.VUE_APP_TRANSLATE_APP_ID || process.env.VUE_APP_TRANSLATE_APP_ID,
      translateAS: config.VUE_APP_TRANSLATE_APP_SK || process.env.VUE_APP_TRANSLATE_APP_SK,
      mapGDT: config.VUE_APP_MAP_GAODE_Tk || process.env.VUE_APP_MAP_GAODE_Tk,
      mapTDT: config.VUE_APP_MAP_TIANDI_Tk || process.env.VUE_APP_MAP_TIANDI_Tk,
    })
  }
})

// 调用3d图表
highcharts3d(highcharts)
/* eslint-disable no-new */
// 登陆过并且有权限的用户初始化websocket,非对外实时视频页面
if (getSession('access_token')) {
  let url = window.location.href
  if (url.indexOf('realvideo') < 0 && !url.includes('/monitor') && !url.includes('/externalHistory') && !url.includes('/Intercom')) {
    let permsCode = sessionStorage.getItem('featureCode')
    if (permsCode) {
      createSocket()
      creatGK3Socket()
    }
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
